// Belt to the mirror's suspenders: on pagehide / tab-hidden, rewrite the
// session mirror from canonical state and kick a final async IDB write.
// This covers clean navigations and backgrounding. It deliberately does NOT
// use beforeunload (unreliable on mobile, breaks bfcache) — and no handler
// covers an iOS memory-pressure kill, which is why the per-mutation mirror
// (sessionMirror.ts) is the primary defense, not this.
import { flushNow } from './persistence';

export function initLifecycleFlush(): () => void {
  const onVisibility = () => {
    if (document.visibilityState === 'hidden') flushNow();
  };
  const onPageHide = () => flushNow();
  document.addEventListener('visibilitychange', onVisibility);
  window.addEventListener('pagehide', onPageHide);
  return () => {
    document.removeEventListener('visibilitychange', onVisibility);
    window.removeEventListener('pagehide', onPageHide);
  };
}
